module.exports = __webpack_public_path__ + "media/3-2.f3b5b0f0.mp4";